import { API_ROOT } from '../../config/config'
import { doPost, doPutFiles } from './utils'

export const saveAttorneyType = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/submit/attorney`
  return doPost(url, request)
}

export const saveAttorneyPerson = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/submit/attorney`
  return doPutFiles(url, request)
}
